import './ColorBar.scss';

import type { ReactNode, FC } from 'react';

interface Props {
  children: ReactNode;
}

export const ColorBar: FC<Props> = (props) => {
  return <div className="ColorBar">{props.children}</div>;
};

export default ColorBar;
